import * as React from "react";
import { forwardRef } from "react";
const SvgLogoType = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 200 28", role: "img", "aria-label": "Personeo", ref, ...props }, /* @__PURE__ */ React.createElement("text", { x: 0, y: 20, fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", fontSize: 20, fontWeight: 300, letterSpacing: 2.5, fill: "currentColor" }, "personeo"));
const ForwardRef = forwardRef(SvgLogoType);
export default ForwardRef;
